module.exports = __webpack_public_path__ + "static/media/mac_pro.55ead495.svg";